import GsfMail from "@/assets/icon/gsf-mail-icon.svg";
const GsfMailIcon = () => {
  return <GsfMail />;
};
export default GsfMailIcon;